import React from "react";

interface PowerPlantNameDisplayProps {
  name: string | string[];
  className?: string;
  badgeBg?: string; // e.g. "bg-grey200" or "bg-grey400"
}

export const PowerPlantNameDisplay: React.FC<PowerPlantNameDisplayProps> = ({
  name,
  className = "",
  badgeBg = "bg-grey200",
}) => {
  if (!name) return null;

  const namesList = Array.isArray(name)
    ? name.map((n) => n.trim()).filter(Boolean)
    : name
        .split(",")
        .map((n) => n.trim())
        .filter(Boolean);

  if (namesList.length === 0) return null;

  const firstName = namesList[0];
  const hiddenNames = namesList.slice(1);

  if (hiddenNames.length === 0) {
    return <span className={className}>{firstName}</span>;
  }

  return (
    <span className={`inline-flex items-center gap-1.5 ${className}`}>
      <span>{firstName}</span>
      <span className="group relative shrink-0">
        <span
          className={`flex size-6 cursor-pointer items-center justify-center rounded-full ${badgeBg} text-xs font-bold text-grey800 transition-colors hover:bg-grey400`}
        >
          +{hiddenNames.length}
        </span>
        <div className="pointer-events-none absolute bottom-full left-1/2 z-[99999] mb-2 hidden w-max max-w-xs -translate-x-1/2 flex-col rounded-xl bg-grey900 p-2.5 text-xs text-white shadow-2xl group-hover:flex">
          <div className="flex flex-col gap-1">
            {hiddenNames.map((hiddenName, idx) => (
              <span key={idx} className="font-medium">
                • {hiddenName}
              </span>
            ))}
          </div>
        </div>
      </span>
    </span>
  );
};

export default PowerPlantNameDisplay;
